import range from 'lodash/range';
import { timeout } from 'd3-timer';

import { forceSimulation, forceCollide, forceX, forceY } from 'd3-force';

export const setupForce = rScale => {
  return forceSimulation()
    .force(
      'collide',
      forceCollide(function(d) {
        if (!d.budget) return 10;
        return rScale(d.budget) + 1;
      }).iterations(1)
    )
    .alphaDecay(0.05)
    .force('y', forceY(0))
    .force('x', forceX(0));
};

const disableForceAnimation = simulation => {
  const tickRange = Math.ceil(
    Math.log(simulation.alphaMin()) / Math.log(1 - simulation.alphaDecay())
  );

  range(tickRange).forEach(function() {
    timeout(function tick() {
      simulation.tick();
    }, 10);
  });
};

export const setCirclePosFromForce = (selection, simulation, data) => {
  const ticked = function() {
    selection
      .attr('cx', function(d) {
        return d.x;
      })
      .attr('cy', function(d) {
        return d.y;
      });
  };
  simulation.nodes(data).on('tick', ticked);
  disableForceAnimation(simulation);
};



// WEBPACK FOOTER //
// ./src/components/bubble-chart/force-helpers.js